    <template>
    <v-container ref="pageActions" fluid tag="section">
        <material-card icon="mdi-clipboard-text" icon-small title="Серії" color="accent" class="mb-16">
            <!--Фильтры-->
            <v-row class="mx-2 mb-2">
                <v-col cols="12" md="3">
                    <v-select return-object item-text="name" item-value="name" v-model="project" :items="projects"
                        label="Проект" clearable @change="setQueryParam()"></v-select>
                </v-col>
                <v-col cols="12" md="3">
                    <v-text-field v-model="typhoonId" label="Код Тайфун товару" clearable single-line
                        hide-details @change="setQueryParam()"></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Пошук" single-line
                        hide-details></v-text-field>
                </v-col>
            </v-row>

            <!--Таблица-->
            <v-data-table :headers="headers" :items="items" class="elevation-1" :search="search"
                :footer-props="{ itemsPerPageOptions: [5, 10, 20, 50, 100, -1] }" :options="{ itemsPerPage }">
                <template v-slot:item.action="{ item }">
                    <v-btn icon :to="`/series/${item.id}`">
                        <v-icon color="blue">mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn icon @click="deleteSeries(item)">
                        <v-icon color="red">mdi-delete</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
            <!--Диалоговое окно для удаления-->
            <DialogConfitmDelete ref="dialogConfirmDelete" />
            <Preloader v-if="isSending" />
        </material-card>

        <v-btn v-if="isManager || isAdmin" class="add-user__button" fab dark color="primary" to="/series/add/">
            <v-icon dark>
                mdi-plus
            </v-icon>
        </v-btn>

    </v-container>
</template>

<script>
import { HTTP } from '@/http-common';
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { IMAGE_BASE_URL } from '@/env.config';

export default {
    name: 'RegularTablesView',
    data() {
        return {
            // Текущий проект
            project: {},
            // Количество элементов на странице
            itemsPerPage: 50,
            // Количество страниц
            isSending: false,
            headers: [
                { text: 'ID', value: 'id' },
                { text: 'Вкл.', value: 'is_active' },
                { text: 'Назва', value: 'name' },
                { text: 'url', value: 'url', },
                { text: 'Порядок', value: 'order' },
                { text: 'Кільк. товарів', value: 'goods_cnt' },
                { text: 'Проект', value: 'project_name' },
                { text: 'Управління', value: 'action', sortable: false },
            ],
            items: [],
            search: '',
            typhoonId: null,
        }
    },
    computed: {
        ...mapGetters(['isManager', 'isAdmin', 'projects']),
    },

    mounted() {
        this.init();
    },

    watch: {
        // '$route': {
        //     handler() {
        //         this.getActions();
        //     },
        //     deep: true,
        // }
    },

    methods: {
        ...mapMutations(['setSnackbar']),
        ...mapActions(['getProjects']),

        async init() {
            await this.getProjects();
            await this.getSeriesList();

        },
        async getSeriesList() {
            this.isSending = true;
            try {
                let { data } = await HTTP.post('/get-series-list', {
                    project_id: this.project.id,
                    typhoon_id: this.typhoonId,
                });
                this.items = data.content;
            } catch (e) {
                this.setSnackbar({ color: 'error', text: e.message || e });
            } finally {
                this.isSending = false;
            }
        },
        setQueryParam() {
            this.getSeriesList();
        },
        async deleteSeries(item) {
            let isConfirmDelete = await this.$refs.dialogConfirmDelete.callDialog();
            if (!isConfirmDelete) return;
            this.isSending = true;

            try {
                await HTTP.post('/delete-series', { id: item.id });
                await this.getSeriesList();
            } catch (e) {
                this.setSnackbar({ color: 'error', text: e.message || e });
            } finally {
                this.isSending = false;
            }
        },
    },
}

</script>

<style>
.add-user__button {
    position: fixed;
    bottom: 20px;
    right: 20px;
}
</style>
